'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getIn from 'transmute/getIn';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { APPLE_EMAIL_PRIVACY_URL } from '../constants/appleEmailPrivacy';
import { EMAIL_CAMPAIGN } from '../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { isOperatorAffectedByEmailPrivacy } from '../utilities/isAffectedByEmailPrivacy';
import FilterOperatorType from './propTypes/FilterOperatorType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApplePrivacyEmailFilterBanner = props => {
  const {
    condition
  } = props;
  const isMarketingEmailFilter = getIn(['field', 'type'], condition) === EMAIL_CAMPAIGN;
  const isAffectedByEmailPrivacy = condition && (isOperatorAffectedByEmailPrivacy(condition) || isMarketingEmailFilter);
  if (!isAffectedByEmailPrivacy) {
    return null;
  }
  const bannerMessage = isMarketingEmailFilter ? 'customerDataFilters.appleEmailPrivacy.filterBanner.marketingEmailFilter' : 'customerDataFilters.appleEmailPrivacy.filterBanner.contactFilter';
  return /*#__PURE__*/_jsxs(UIAlert, {
    className: "m-bottom-2 p-x-4",
    style: {
      minHeight: 'unset'
    } // this is required to make the UIAlert not strictly 60px high, which is the value minHeight is set to
    ,
    type: "warning",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: bannerMessage
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: UILink
        },
        message: "customerDataFilters.appleEmailPrivacy.filterBanner.link_jsx",
        options: {
          external: true,
          href: APPLE_EMAIL_PRIVACY_URL
        }
      })
    })]
  });
};
ApplePrivacyEmailFilterBanner.propTypes = {
  condition: FilterOperatorType
};
export default ApplePrivacyEmailFilterBanner;